import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';

export const supportedLanguages = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'ar', label: 'العربية', dir: 'rtl' },
  { code: 'fr', label: 'Français', dir: 'ltr' },
] as const;

export type LangCode = (typeof supportedLanguages)[number]['code'];

const defaultLanguage = supportedLanguages[0];
const supportedLanguageMap = new Map(supportedLanguages.map((lang) => [lang.code, lang]));

const normalizeLanguageCode = (lng?: string) => (lng ?? '').toLowerCase().split('-')[0];

export const resolveSupportedLanguage = (lng?: string) => {
  const normalizedCode = normalizeLanguageCode(lng) as LangCode;
  return supportedLanguageMap.get(normalizedCode) ?? defaultLanguage;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    supportedLngs: supportedLanguages.map((lang) => lang.code),
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    cleanCode: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

const applyDir = (lng: string) => {
  const lang = resolveSupportedLanguage(lng);
  const dir = lang.dir ?? 'ltr';

  document.documentElement.dir = dir;
  document.documentElement.lang = lang.code;
};

applyDir(i18n.resolvedLanguage ?? i18n.language);
i18n.on('languageChanged', applyDir);

export default i18n;
